// Playful color "mark" for the color category banner.
// Replaces a plain color circle with a Murano mushroom-lamp silhouette
// filled with the category's swatch color. Pure decoration.

type Props = { color: string; className?: string };

export function ColorMushroomMark({ color, className }: Props) {
  return (
    <svg
      viewBox="0 0 140 180"
      className={className}
      aria-hidden
      fill="none"
    >
      {/* Shade */}
      <path
        d="M10 75 Q70 -5 130 75 Q130 82 122 84 L18 84 Q10 82 10 75 Z"
        fill={color}
        stroke="currentColor"
        strokeOpacity="0.18"
        strokeWidth="1"
      />
      {/* Shade highlight */}
      <path
        d="M28 70 Q70 22 112 70"
        stroke="white"
        strokeOpacity="0.35"
        strokeWidth="1.2"
        fill="none"
      />
      {/* Neck */}
      <path
        d="M58 84 L60 130 L80 130 L82 84 Z"
        fill={color}
        stroke="currentColor"
        strokeOpacity="0.18"
        strokeWidth="1"
      />
      {/* Base */}
      <path
        d="M44 130 Q70 142 96 130 L102 158 Q70 172 38 158 Z"
        fill={color}
        stroke="currentColor"
        strokeOpacity="0.18"
        strokeWidth="1"
      />
      {/* Subtle base shadow */}
      <ellipse cx="70" cy="172" rx="38" ry="3" fill="currentColor" fillOpacity="0.08" />
    </svg>
  );
}
